export const CLIENT_ID = process.env.CLIENT_ID || "AeopMUp3mlN2peQggoFFPQov5ZPzPQ2I-bpFbBgpb9QDW9umhUxIkjlGtxNisH8TImmp4fFIkzxpT8NR"
export const APP_SECRET = process.env.APP_SECRET || "AeopMUp3mlN2peQggoFFPQov5ZPzPQ2I-bpFbBgpb9QDW9umhUxIkjlGtxNisH8TImmp4fFIkzxpT8NR"
